__turbopack_context__.v({
  "iconButton": "VRtrja_iconButton",
  "innerIcon": "VRtrja_innerIcon",
  "wrapper": "VRtrja_wrapper",
});
